import { TITLE_PREFIX, RI_INDEX_ROUTE } from './consts';

export default () => ({
    label: TITLE_PREFIX,
    link: RI_INDEX_ROUTE,
    icon: 'resInventory',
    permission: ['purchase orders - stocks.receive'],
    order: 50,
});
